import { SectionContent } from '@/contexts/ContentContext';

interface HeroFormProps {
  content: SectionContent;
  onChange: (field: string, value: string) => void;
}

export function HeroForm({ content, onChange }: HeroFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Título Principal
        </label>
        <input
          type="text"
          value={content.title || ''}
          onChange={(e) => onChange('title', e.target.value)}
          className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Subtítulo
        </label>
        <input
          type="text"
          value={content.subtitle || ''}
          onChange={(e) => onChange('subtitle', e.target.value)}
          className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Descrição Principal
        </label>
        <textarea
          rows={2}
          value={content.description || ''}
          onChange={(e) => onChange('description', e.target.value)}
          className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Descrição Secundária
        </label>
        <textarea
          rows={2}
          value={content.subDescription || ''}
          onChange={(e) => onChange('subDescription', e.target.value)}
          className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Texto do Botão
        </label>
        <input
          type="text"
          value={content.cta || ''}
          onChange={(e) => onChange('cta', e.target.value)}
          className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
        />
      </div>
    </div>
  );
}
